import { withStyles } from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { ORANGE, RED, V364_SYNC_STATUS, VEGA_SYNCHRONIZATION_ERROR_MESSAGES } from '../../_config/consts';
import MDButton from '../MDButton/MDButton.jsx';


const styles = theme => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  titleText: {
    marginRight: 5,
    marginBottom: 5,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'left',
  },
  sectionText: {
    margin: 0,
    marginRight: 5,
    fontSize: 18,
    lineHeight: 1.4,
    color: '#878787',
    textAlign: 'left',
  },
  warningTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    marginTop: -20,
  },
  errorCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const ErrorRow = ({ error, isEaven, onSyncVegaSmartLock, onSyncVegaSmartLockForGateId }) => {
  const backgroundColor = !isEaven ? '#FAFAFA' : 'white';
  const errorConfig = VEGA_SYNCHRONIZATION_ERROR_MESSAGES[error.errorCode];
  
  return (
    <div
      className="card-noHover tag-element-selected"
      style={{ display: 'flex', zIndex: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 5, marginBottom: 0, marginTop: 0, backgroundColor, padding: 10 }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {error.syncStatus === V364_SYNC_STATUS.NOT_SYNCED_SERIAL_NUMBER ? (
        <>
          <h5 style={{ margin: 0, marginTop: 5, color: '#3f3f3f', fontSize: 18 }}>
            <span style={{ fontWeight: 'bold' }}><Entity entity="vegaName" />:</span> {error.vegaSerialNumber} <span style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: 20 }}>≠</span> <span style={{ fontWeight: 'bold' }}><Entity entity="luckeyName" />:</span> {error.lockSerialNumber}
          </h5>
          <h6 style={{ margin: 0, marginTop: 8, color: '#878787', fontSize: 14 }}>
            <span style={{ fontWeight: 'bold' }}>V364 Door ID: {error.extId}</span>
          </h6>
        </>
        ): (
          <>
          <h5 style={{ margin: 0, marginTop: 5, color: '#3f3f3f', fontSize: 18 }}>
            <span style={{ fontWeight: 'bold' }}>{error.lockSerialNumber} (Gate ID: {error.extId})</span>
          </h5>
          </>
        )}
        <h6 style={{ margin: 0, marginTop: 8, color: '#d32f2f', fontSize: 14 }}>
          {errorConfig ? (
            <Entity 
              entity={errorConfig.string} 
              data={{ 
                lockSerialNumber: error.lockSerialNumber, 
                vegaSerialNumber: error.vegaSerialNumber, 
                extId: error.extId 
              }} 
            />
          ) : error.errorMessage}
        </h6>
      </div>
      {error.syncStatus === V364_SYNC_STATUS.NOT_SYNCED_SERIAL_NUMBER && (
        <div style={{ marginLeft: 20 }}>
          <MDButton
            style={{ padding: '8px 16px', minWidth: 100 }}
            title={<Entity entity="forceSynchronization" />}
            backgroundColor={ORANGE}
            onClick={() => onSyncVegaSmartLock(error.smartLockId)}
          />
        </div>
      )}
      {error.syncStatus === V364_SYNC_STATUS.NOT_SYNCED_GATE_ID && (
        <div style={{ marginLeft: 20 }}>
          <MDButton
            style={{ padding: '8px 16px', minWidth: 100 }}
            title={<Entity entity="forceSynchronization" />}
            backgroundColor={ORANGE}
            onClick={() => onSyncVegaSmartLockForGateId(error.smartLockId)}
          />
        </div>
      )}
    </div>
  );
};

const V364SyncErrorsModal = ({ classes, errors, onClose, onSyncVegaSmartLock, onSyncVegaSmartLockForGateId }) => (
  <div style={{ marginLeft: 13, marginBottom: 30, padding: 10 }}>
    <div className={classes.warningTitleContainer}>
      <Warning style={{ color: 'orange', fontSize: 40 }} />
      <h2 className={classes.titleText} style={{ margin: 0, marginLeft: 10, fontSize: 25 }}>
        <Entity entity="v364SyncErrorsTitle" />
      </h2>
    </div>
    <h2 className={classes.sectionText} style={{ marginTop: 18, textAlign: 'center', color: '#3f3f3f' }}>
      <Entity entity="v364SyncErrorsMessage" />
    </h2>
    <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10, marginTop: 20 }}>
      <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          {_.map(errors, (error, index) =>
            <ErrorRow
              key={error.smartLockId || index}
              error={error}
              isEaven={index % 2 === 0}
              onSyncVegaSmartLock={onSyncVegaSmartLock}
              onSyncVegaSmartLockForGateId={onSyncVegaSmartLockForGateId}
            />,
          )}
        </div>
      </div>
    </div>
    <MDButton
      title={<Entity entity="close" />}
      backgroundColor={RED}
      onClick={() => onClose()}
    />
  </div>
);

export default withStyles(styles)(V364SyncErrorsModal);
